import Vue from 'vue'
import Main from './notification.vue'
import merge from '../utils/merge'
import { PopupManager } from '../utils/popup'
import { isVNode } from '../utils/vdom'
const NotificationConstructor = Vue.extend(Main)

let instance
let instances = []
let seed = 1

const Notification = function(options) {
  if (Vue.prototype.$isServer) { return }
  options = merge({}, options)
  const userOnClose = options.onClose
  let id

  if (options.id && !instances.find(i => i.id === options.id)) {
    id = options.id
  } else {
    id = 'notification_' + seed++
  }


  const position = options.position || 'top-right'

  options.removeInInstances = function() {
    Notification.close(id, userOnClose)
  }

  instance = new NotificationConstructor({
    data: options
  })

  if (isVNode(options.message)) {
    instance.$slots.default = [options.message]
    options.message = 'REPLACED_BY_VNODE'
  }
  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  instance.dom = instance.$el
  instance.dom.style.zIndex = PopupManager.nextZIndex()

  let verticalOffset = options.offset || 0
  instances.filter(item => item.position === position).forEach(item => {
    verticalOffset += item.$el.offsetHeight + 16
  })
  verticalOffset += 16
  instance.verticalOffset = verticalOffset

  instance.closeText = options.closeText
  instance.clickText = options.clickText
  instances.push(instance)
  return instance
};

['success', 'warning', 'info', 'error'].forEach(type => {
  Notification[type] = options => {
    if (typeof options === 'string' || isVNode(options)) {
      options = {
        message: options
      }
    }
    options.type = type
    return Notification(options)
  }
})

Notification.close = function(id, userOnClose) {
  let index = -1
  const len = instances.length
  const instance = instances.filter((instance, i) => {
    if (instance.id === id) {
      index = i
      return true
    }
    return false
  })[0]
  if (!instance) { return }

  if (typeof userOnClose === 'function') {
    userOnClose(instance)
  }
  instances.splice(index, 1)

  if (len <= 1) { return }
  const position = instance.position
  const removedHeight = instance.dom.offsetHeight
  for (let i = index; i < len - 1 ; i++) {
    if (instances[i].position === position) {
      instances[i].dom.style[instance.verticalProperty] =
        parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px'
    }
  }
}

/**
* Закрыть все сообщения
*/
Notification.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close()
  }
}

/**
* Закрыть конкретное сообщение
*/
Notification.closeById = function(id) {
  const instance = instances.find(i => i.id === id)
  if (instance) { instance.close() }
}

/**
* Изменить конкретное сообщение
*/
Notification.update = function(options, id) {
  id = id || options.id
  const instance = instances.find(i => i.id === id)
  if (instance) {
    instance.title = checkValue(options.title, instance.title)
    instance.type = checkValue(options.type, instance.type)
    instance.dataQa = checkValue(options.dataQa, instance.dataQa)
    instance.dangerouslyUseHTMLString = checkValue(options.dangerouslyUseHTMLString, instance.dangerouslyUseHTMLString)
    instance.duration = checkValue(options.duration, instance.duration)
    instance.position = checkValue(options.position, instance.position)
    instance.showClose = checkValue(options.showClose, instance.showClose)
    instance.closeText = checkValue(options.closeText, instance.closeText)
    instance.clickText = checkValue(options.clickText, instance.clickText)
    instance.message = checkValue(options.message, instance.message)
    instance.progress = checkValue(options.progress, instance.progress)
    instance.loading = checkValue(options.loading, instance.loading)
    instance.onClick = checkValue(options.onClick, instance.onClick)
    instance.onCloseBtnClick = checkValue(options.onCloseBtnClick, instance.onCloseBtnClick)
    instance.onClose = checkValue(options.onClose, instance.onClose)

    instance.startTimer()
  } else {
    options.id = id
    Notification(options)
  }
}

/**
* Список всех сообщений
*/
Notification.instances = instances

const checkValue = function(value, defaultValue) {
  if (value === undefined) {
    return defaultValue
  }
  return value
}

export default Notification
